/**
 * AAA IDP Licence Class reducer
 * 
 */
import { DELETE, LICENCE_CLASS, VALIDATE } from '../../actions/types';
export const initialState = {
  error: false,
  required: true,
  valid: null,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case LICENCE_CLASS:
      {
        let {
          required
        } = state;
        const {
          value
        } = action;
        const valid = value === '' && required ? false : true;
        return {
          error: !valid,
          required,
          valid,
          value
        };
      }
    case VALIDATE:
      {
        const valid = state.value === '' && state.required ? false : true;
        return {
          ...state,
          error: !valid,
          valid
        };
      }
    default:
      return state;
  }
}